<div class="main-screen-component">
    <div>
        @for (item of menuService.getMenu(); track item.label) {
            <app-menu-card [menuItem]="item"></app-menu-card>
            } @empty {
            <div></div>
            }
     </div>
</div>

